export default {
  "account": {
    "curatedCollections": "Kureeritud kogud",
    "curatedCollectionsInfo": "Allpool leiate kõik kogud, mida olete kureerinud",
    "editProfile": "Muuda profiili",
    "likes": "Meeldimised",
    "linkAccount": "Minu konto",
    "linkLogin": "Logi sisse",
    "linkLoginJoin": "Logi sisse/Liitu",
    "linkLogout": "Logi välja",
    "myProfile": "Minu profiil",
    "notifications": {
      "loggedIn": "Olete nüüd sisse logitud. Tere tulemast!",
      "loggedOut": "Olete nüüd välja logitud.",
      "noCollections": {
        "curated": "Te pole veel ühtegi kollektsiooni kureerinud",
        "private": "Te pole veel ühtegi privaatset galeriid loonud",
        "public": "Te pole veel ühtegi avalikku galeriid loonud"
      },
      "noLikedItems": "Teile pole veel ükski toode meeldinud"
    },
    "privateCollections": "Privaatgaleriid",
    "profile": "Minu meeldimised ja galeriid",
    "profileSettings": "Profiili seaded",
    "publicCollections": "Avalikud galeriid",
    "settings": "Seaded",
    "title": "Minu konto"
  },
  "actions": {
    "accept": "Nõustu",
    "cancel": "Tühista",
    "close": "Sulge",
    "continue": "jätka",
    "download": "Lae alla",
    "edit": "Muuda",
    "feedback": "Tagasiside",
    "goBack": "Mine tagasi",
    "goHome": "Minge avalehele",
    "learnMore": "Lisateave",
    "like": "Meeldib",
    "move": "Liiguta",
    "next": "Järgmine",
    "pin": "Pin",
    "preview": "Eelvaade",
    "previous": "Eelmine",
    "providedBy": "Pakub {provider}",
    "reject": "Tagasi lükata",
    "save": "Salvesta",
    "send": "Saada",
    "share": "Jagage",
    "shareOn": "Jagage saidil {social}",
    "skip": "Vahele jätma",
    "viewAt": "Kuva saidil {link}",
    "viewDocument": "Vaadake dokumenti"
  },
  "attribution": {
    "country": "Riik:",
    "creator": "Looja:",
    "date": "Kuupäev:",
    "institution": "Institutsioon:",
    "title": "Pealkiri:"
  },
  "automatedCardGroup": {
    "item": "Hiljutised esemed",
    "organisation": "Organisatsioonid",
    "place": "Kohad",
    "time": "Esiletõstetud sajandid",
    "topic": "Esile tõstetud teemad"
  },
  "blog": {
    "author": "Autor",
    "authors": "Autorid",
    "blog": "Blogi",
    "by": "poolt",
    "categories": "Kategooriad",
    "category": "Kategooria",
    "posts": "Blogipostitused",
    "published": "Avaldatud {date}",
    "relatedPosts": "Seonduvad postitused"
  },
  "cardLabels": {
    "organisation": "Organisatsioon",
    "person": "Isik",
    "place": "Koht",
    "theme": "Teema",
    "time": "Sajand",
    "topic": "Teema"
  },
  "clearAllFilters": "tühjenda kõik filtrid",
  "collections": {
    "actions": {
      "edit": "Muuda kogu",
      "update": "Värskendus Kollektsiooni"
    },
    "fashion": {
      "facets": {
        "CREATOR": {
          "moreName": "disainerid",
          "name": "Disainer | Disainerid",
          "select": "Valige disainerid"
        },
        "proxy_dc_format": {
          "moreName": "tehnikad",
          "name": "Tehnika | Tehnikad",
          "select": "Valige tehnikad"
        },
        "proxy_dc_type": {
          "moreName": "kauba tüübid",
          "name": "Kauba tüüp | Kauba tüübid",
          "select": "Valige üksuste tüübid"
        },
        "proxy_dcterms_medium": {
          "moreName": "materjalid",
          "name": "Materjal | Materjalid",
          "select": "Valige materjalid"
        }
      }
    },
    "form": {
      "description": "Kirjeldus"
    },
    "notifications": {
      "update": "Kollektsiooni on uuendatud"
    }
  },
  "collectionsYouMightLike": "Kollektsioonid, mis võivad teile meeldida",
  "colourSwatch": "Värvivalik",
  "contentYouMightLike": "Sisu, mis võib teile meeldida",
  "contentfulManual": {
    "footerNavigation": {
      "MoreInfoLabel": "Rohkem infot",
      "about": "Infot Europeana kohta",
      "forDevelopers": "Arendajatele",
      "help": "Abimaterjal",
      "meetUs": "Tutvu meeskonnaga",
      "provide": "Hakka andmepakkujaks",
      "subscribe": "Telli meie uudiskiri",
      "terms": "Kasutustingimused ja privaatsuspoliitika"
    },
    "headerNavigation": {
      "Collections": "Kollektsioonid",
      "explore": "Tutvuge",
      "teachers": "Õpetajad"
    }
  },
  "curatedAutomatically": "Kuraator on automaatselt Europeana",
  "dateFilter": {
    "endDate": "Lõppkuupäev",
    "specificDate": "Konkreetne kuupäev",
    "startDate": "Alguskuupäev",
    "to": "kuni"
  },
  "debug": {
    "apiRequests": {
      "apiKeyLinkText": "Europeana API võti",
      "noRequests": "Sellel lehel ei kasutatud Europeana API-de päringuid.",
      "settingsPageLinkText": "seadete leht",
      "tip": "Nõuanne: kui teil on juba {apiKeyLink} , võite selle sisestada lehel {settingsPageLink} ja see lisatakse nendele API päringu linkidele.",
      "title": "API taotlused"
    },
    "debug": "Debug",
    "settings": {
      "form": {
        "apiKey": {
          "description": "Sisestage oma Europeana API võti ja seda kasutatakse API taotluste linkides.",
          "label": "API võti"
        },
        "enabled": {
          "description": "Kui see on lubatud, kuvatakse lehe jaluses silumismenüü.",
          "label": "Luba silumismenüü"
        }
      },
      "title": "Seaded"
    }
  },
  "delete": "Kustuta",
  "depiction": "{title} kujutis",
  "directions": {
    "left": "Vasak",
    "right": "Parem"
  },
  "edmIsShownAtLinkAlt": "Vaadake teenusepakkuja veebisaidil",
  "entity": {
    "actions": {
      "cancel": "Tühista",
      "pin": "Pin üksus",
      "unpin": "Eemaldage üksus",
      "viewPinned": "Vaadake kinnitatud üksusi"
    },
    "labels": {
      "entity": "Üksus"
    },
    "notifications": {
      "deleted": "Teie galerii on kustutatud.",
      "error": {
        "unpin": "Üksuse vabastamisel ilmnes viga. Proovige uuesti või teavitage probleemist."
      },
      "pin": "See üksus kuvatakse kogu „ {entity} ” ülaosas. Anname teile teada, kui seda muudatust kogumislehel näha on.",
      "pinLimit": {
        "body": "Praegu saate esimesele lehele kinnitada ainult 24 üksust. Kui soovite selle üksuse kinnitada, eemaldage kindlasti uus üksus ja proovige siis seda uuesti kinnitada.",
        "title": "Liiga palju kinnitatud üksusi"
      },
      "pinned": "Üksus on kinnitatud. See on nüüd selle kogumiku esimese lehe ülaosas. Kõigi kuvamiseks võib kuluda kuni 24 tundi.",
      "select": "Valige seotud olem üksuse kinnitamiseks/eemaldamiseks selle külge/välja.",
      "unpin": "Seda üksust ei kuvata enam kogu „ {entity} ” ülaosas. Anname teile teada, kui seda muudatust kogumislehel näha on.",
      "unpinned": "Üksus on vabastatud. Seda pole enam selle kogumiku esimese lehe ülaosas. Kõigi kadumiseks võib kuluda kuni 24 tundi."
    }
  },
  "error": "Viga",
  "errorMessage": {
    "galleryUnauthorised": {
      "description": "See pole võimalik, kuna privaatgaleriid on nähtavad ainult nende loojale. Kui teate galerii loojat, paluge tal galerii avalikustada. Teise võimalusena teavitage sellest probleemist tagasiside nupuga.",
      "metaTitle": "Galerii volitamata",
      "title": "Ups! {newline} Sa üritad vaadata teise isiku privaat galeriid."
    },
    "itemNotFound": {
      "description": "Selle põhjuseks võivad olla järgmised põhjused: seda üksust pole olemas või; see tühistati, kuna see ei vastanud meie kvaliteedikriteeriumidele või; seda värskendati ja avaldati uuesti uue kordumatu identifikaatoriga. Sel juhul proovige üksust uuesti leida.",
      "metaTitle": "Üksust ei leitud",
      "title": "Oh ei! {newline} Me ei leidnud seda üksust."
    }
  },
  "exhibitions": {
    "chapters": "Peatükid",
    "credits": "Autorid",
    "currentChapter": "Praegune peatükk",
    "description": "Tutvuge näitustega",
    "exhibitions": "Näitused"
  },
  "explore": "Avasta",
  "facets": {
    "COLOURPALETTE": {
      "moreName": "värvid",
      "name": "Värv | Värvid",
      "options": {
        "#000000": "Must",
        "#000080": "Mereväe sinine",
        "#00008B": "Tumesinine",
        "#0000CD": "Keskmine sinine",
        "#0000FF": "Sinine",
        "#006400": "Tumeroheline",
        "#008000": "Veebiroheline",
        "#008080": "Tali",
        "#008B8B": "Tume sinine",
        "#00BFFF": "Deep Sky Blue",
        "#00CED1": "Tume türkiissinine",
        "#00FA9A": "Keskmine kevadine roheline",
        "#00FF00": "Roheline",
        "#00FF7F": "Kevadine roheline",
        "#00FFFF": "Tsüaan",
        "#191970": "Kesköö sinine",
        "#1E90FF": "Dodger Blue",
        "#20B2AA": "Hele meri roheline",
        "#228B22": "Metsaroheline",
        "#2E8B57": "Mereroheline",
        "#2F4F4F": "Tume kiltkivihall",
        "#32CD32": "Laimiroheline",
        "#3CB371": "Keskmise mere roheline",
        "#40E0D0": "Türkiissinine",
        "#4169E1": "Sügavsinine",
        "#4682B4": "Terasinine",
        "#483D8B": "Tume kiltkivi sinine",
        "#48D1CC": "Keskmine türkiissinine",
        "#4B0082": "Indigo",
        "#556B2F": "Tume oliivroheline",
        "#5F9EA0": "Kadett sinine",
        "#6495ED": "Rukkilill",
        "#663399": "Rebecca lilla",
        "#66CDAA": "Keskmine akvamariin",
        "#696969": "Dim Hall",
        "#6A5ACD": "Kiltkivi sinine",
        "#6B8E23": "Olive Drab",
        "#708090": "Kiltkivi hall",
        "#778899": "Hele kiltkivihall",
        "#7B68EE": "Keskmine kiltkivi sinine",
        "#7CFC00": "Muru roheline",
        "#7F0000": "Veebi maroon",
        "#7F007F": "Veebililla",
        "#7FFF00": "Chartreuse",
        "#7FFFD4": "Akvamariin",
        "#800000": "Maroon",
        "#800080": "Lilla",
        "#808000": "Oliiv",
        "#808080": "Veebihall",
        "#87CEEB": "Taevasinine",
        "#87CEFA": "Hele taevasinine",
        "#8A2BE2": "Sinine violetne",
        "#8B0000": "Tumepunane",
        "#8B008B": "Tume magenta",
        "#8B4513": "Saddle pruun",
        "#8FBC8F": "Tume meri roheline",
        "#90EE90": "Heleroheline",
        "#9370DB": "Keskmine lilla",
        "#9400D3": "Tume violetne",
        "#98FB98": "Kahvaturoheline",
        "#9932CC": "Tume orhidee",
        "#9ACD32": "Kollane roheline",
        "#A020F0": "Lilla",
        "#A0522D": "Sienna",
        "#A52A2A": "Pruun",
        "#A9A9A9": "Tumehall",
        "#ADD8E6": "Helesinine",
        "#ADFF2F": "Roheline kollane",
        "#AFEEEE": "Kahvatu türkiis",
        "#B03060": "Maroon",
        "#B0C4DE": "Hele terasinine",
        "#B0E0E6": "Pulber sinine",
        "#B22222": "Firebrick",
        "#B8860B": "Tume Goldenrod",
        "#BA55D3": "Keskmine orhidee",
        "#BC8F8F": "Rosy Brown",
        "#BDB76B": "Tume khaki",
        "#BEBEBE": "Hall",
        "#C0C0C0": "Hõbe",
        "#C71585": "Keskmine violetne punane",
        "#CD5C5C": "India punane",
        "#CD853F": "Peruu",
        "#D2691E": "Šokolaad",
        "#D2B48C": "Tan",
        "#D3D3D3": "Helehall",
        "#D8BFD8": "Ohakas",
        "#DA70D6": "Orhidee",
        "#DAA520": "Goldenrod",
        "#DB7093": "Kahvatu violetne punane",
        "#DC143C": "Karmiinpunane",
        "#DCDCDC": "Gainsboro",
        "#DDA0DD": "Ploom",
        "#DEB887": "Burlywood",
        "#E0FFFF": "Hele tsüaan",
        "#E6E6FA": "Lavendel",
        "#E9967A": "Tume lõhe",
        "#EE82EE": "violetne",
        "#EEE8AA": "Kahvatu Goldenrod",
        "#F08080": "Hele korall",
        "#F0E68C": "Khaki",
        "#F0F8FF": "Alice Blue",
        "#F0FFF0": "Mesilane",
        "#F0FFFF": "Azure",
        "#F4A460": "Sandy Brown",
        "#F5DEB3": "Nisu",
        "#F5F5DC": "Beež",
        "#F5F5F5": "Valge suits",
        "#F5FFFA": "Mint kreem",
        "#F8F8FF": "Kummitus valge",
        "#FA8072": "Lõhe",
        "#FAEBD7": "Antiikvalge",
        "#FAF0E6": "Linane",
        "#FAFAD2": "Hele kuldne",
        "#FDF5E6": "Old Lace",
        "#FF0000": "Punane",
        "#FF00FF": "Fuksia",
        "#FF1493": "Sügav roosa",
        "#FF4500": "Oranžpunane",
        "#FF6347": "Tomat",
        "#FF69B4": "Kuum roosa",
        "#FF7F50": "Korall",
        "#FF8C00": "Tumeoranž",
        "#FFA07A": "Hele lõhe",
        "#FFA500": "Oranž",
        "#FFB6C1": "Heleroosa",
        "#FFC0CB": "Roosa",
        "#FFD700": "Kuld",
        "#FFDAB9": "Virsikupuu",
        "#FFDEAD": "Navajo valge",
        "#FFE4B5": "Mokassiin",
        "#FFE4C4": "Bisque",
        "#FFE4E1": "Udune roos",
        "#FFEBCD": "Blanšeeritud mandel",
        "#FFEFD5": "Papaia piits",
        "#FFF0F5": "Lavendel põsepuna",
        "#FFF5EE": "Merekarp",
        "#FFF8DC": "Cornsilk",
        "#FFFACD": "Sidruni šifoon",
        "#FFFAF0": "Õie valge",
        "#FFFAFA": "Lumi",
        "#FFFF00": "Kollane",
        "#FFFFE0": "Helekollane",
        "#FFFFF0": "Elevandiluu",
        "#FFFFFF": "Valge"
      },
      "select": "Valige värvid"
    },
    "COUNTRY": {
      "name": "Pakkuja riik",
      "options": {
        "Albania": "Albaania",
        "Austria": "Austria",
        "Belarus": "Valgevene",
        "Belgium": "Belgia",
        "Bosnia and Herzegovina": "Bosnia ja Hertsegoviina",
        "Bulgaria": "Bulgaaria",
        "Croatia": "Horvaatia",
        "Cyprus": "Küpros",
        "Czech Republic": "Tšehhi Vabariik",
        "Denmark": "Taani",
        "Estonia": "Eesti",
        "Europe": "Euroopa",
        "Finland": "Soome",
        "France": "Prantsusmaa",
        "Georgia": "Gruusia",
        "Germany": "Saksamaa",
        "Greece": "Kreeka",
        "Holy See (Vatican City State)": "Püha Tool (Vatikani Linnriik)",
        "Hungary": "Ungari",
        "Iceland": "Island",
        "Ireland": "Iirimaa",
        "Israel": "Iisrael",
        "Italy": "Itaalia",
        "Latvia": "Läti",
        "Lithuania": "Leedu",
        "Luxembourg": "Luksemburg",
        "Macedonia": "Makedoonia",
        "Malta": "Malta",
        "Moldova": "Moldova",
        "Montenegro": "Montenegro",
        "Netherlands": "Holland",
        "Norway": "Norra",
        "Poland": "Poola",
        "Portugal": "Portugal",
        "Romania": "Rumeenia",
        "Russia": "Venemaa",
        "Serbia": "Serbia",
        "Slovakia": "Slovakkia",
        "Slovenia": "Sloveenia",
        "Spain": "Hispaania",
        "Sweden": "Rootsi",
        "Switzerland": "Šveits",
        "Turkey": "Türgi",
        "Ukraine": "Ukraina",
        "United Kingdom": "Ühendkuningriik",
        "United States of America": "Ameerika Ühendriigid"
      },
      "select": "Valige pakkuvad riigid"
    },
    "CREATOR": {
      "moreName": "loojad",
      "name": "Looja | Loojad",
      "select": "Valige loojad"
    },
    "DATA_PROVIDER": {
      "moreName": "institutsioonid",
      "name": "Institutsioon",
      "select": "Valige institutsioonid"
    },
    "IMAGE_ASPECTRATIO": {
      "name": "Kujutise orientatsioon | Kujutise orientatsioonid",
      "options": {
        "landscape": "Maastik",
        "portrait": "Portree"
      },
      "select": "Valige pildi orientatsioon"
    },
    "IMAGE_SIZE": {
      "name": "Pildi suurus | Pildi suurused",
      "options": {
        "extra_large": "Eriti suur 4MP + (nt 2688 x 1520 pikslit)",
        "large": "Suur 1–4 MP (nt 1920x1080 pikslit)",
        "medium": "Keskmine 0,5–1 MP (nt 850x850 pikslit)",
        "small": "Väike < 0,5 MP (nt 650x600 pikslit)"
      },
      "select": "Valige pildi suurused"
    },
    "LANGUAGE": {
      "name": "Keel",
      "options": {
        "ar": "Araabia",
        "bg": "Bulgaaria",
        "bs": "Bosnia",
        "ca": "Katalaani",
        "cs": "Tšehhi",
        "cy": "Kõmri",
        "da": "Taani",
        "de": "Saksa",
        "el": "Kreeka",
        "en": "Inglise",
        "es": "Hispaania",
        "et": "Eesti",
        "fi": "Soome",
        "fr": "Prantsuse",
        "ga": "Iiri",
        "gd": "Gaeli",
        "he": "Heebrea",
        "hr": "Horvaatia",
        "hu": "Ungari",
        "is": "Islandi",
        "it": "Itaalia",
        "lt": "Leedu",
        "lv": "Läti",
        "mk": "Makedoonia",
        "mt": "Malta",
        "mul": "Mitu keelt",
        "nl": "Hollandi",
        "no": "Norra",
        "pl": "Poola",
        "pt": "Portugali",
        "ro": "Rumeenia",
        "ru": "Vene",
        "sk": "Slovaki",
        "sl": "Sloveenia",
        "sq": "Albaania",
        "sr": "Serbia",
        "sv": "Rootsi",
        "tr": "Türgi",
        "uk": "Ukraina"
      },
      "select": "Valige keeled"
    },
    "MIME_TYPE": {
      "name": "Failivorming | Failivormingud",
      "options": {
        "text/plain": "Lihttekst"
      },
      "select": "Valige failivormingud"
    },
    "PROVIDER": {
      "moreName": "agregaatorid",
      "name": "Koondaja",
      "select": "Valige agregaatorid"
    },
    "REUSABILITY": {
      "name": "Kas ma saan seda uuesti kasutada?",
      "options": {
        "open": "Jah",
        "permission": "Võib-olla, küsige luba",
        "restricted": "Jah, tingimustega",
        "uncategorized": "Kategoriseerimata"
      },
      "select": "Valige, kas saate seda kasutada"
    },
    "TYPE": {
      "name": "Meediumitüüp",
      "options": {
        "3D": "3D",
        "IMAGE": "Pilt ",
        "SOUND": "Heli",
        "TEXT": "Tekst",
        "VIDEO": "Video"
      },
      "select": "Valige kandja tüübid"
    },
    "api": {
      "name": "Otsing",
      "options": {
        "fulltext": "Täistekstiga kirjed",
        "metadata": "Ainult metaandmete kirjed"
      },
      "switch": "Otsige ainult täistekstiga üksuste sisust",
      "switchMoreInfo": "Selles kollektsioonis saate valida, mida soovite otsida: kui see lüliti on sisse lülitatud, siis otsite ajalehtede ja dokumentide tekstist; kui see on välja lülitatud, siis otsite selle asemel objekti kirjeldavast teabest, nagu teete seda alati enamikus teistes kollektsioonides."
    },
    "button": {
      "apply": "Kohalda",
      "cancel": "Tühista",
      "morefilters": "Rohkem filtreid",
      "reset": "Lähtesta",
      "showAll": "Kuva kõik {label}",
      "showLess": "Näita vähem {label}"
    },
    "collection": {
      "name": "Teema",
      "options": {
        "archaeology": "Arheoloogia",
        "art": "Kunst",
        "fashion": "Mood",
        "industrial": "Tööstuspärand",
        "manuscript": "Käsikirjad",
        "map": "Kaardid ja geograafia",
        "migration": "Ränne",
        "music": "Muusika",
        "nature": "Looduslugu",
        "newspaper": "Ajalehed",
        "photography": "Fotograafia",
        "sport": "Sport",
        "ww1": "Esimene maailmasõda"
      },
      "select": "Valige teema"
    },
    "contentTier": {
      "name": "Eseme kvaliteet",
      "options": {
        "*": "Sisaldab üksusi, mis ei vasta meie avaldamiskriteeriumidele",
        "0": "Kuva ainult üksused, mis ei vasta meie avaldamiskriteeriumidele",
        "1": "Madal kvaliteet",
        "2": "Keskmine kvaliteet",
        "3": "Kvaliteetne ja korduvkasutatav koos tingimustega",
        "4": "Kvaliteetne ja vabalt taaskasutatav"
      },
      "select": "Valige esemete omadused"
    },
    "moreOptions": "Otsi, et leida {0} rohkem {1}.",
    "proxy_dc_format": {
      "name": "Vorming | Vormingud",
      "select": "Valige vormingud"
    },
    "proxy_dc_type": {
      "name": "Tüüp | Tüübid",
      "select": "Valige tüübid"
    },
    "proxy_dcterms_issued": {
      "name": "Väljaandmise kuupäev"
    },
    "proxy_dcterms_medium": {
      "name": "Meedium | Meediumid",
      "select": "Valige meedia"
    }
  },
  "feedback": {
    "emailOptional": "Võime soovida jätkata. Sisestage oma e-posti aadress, kui olete rahul, et meiega ühendust võtame.",
    "failed": "Taotlus nurjus. Palun proovi uuesti.",
    "form": {
      "placeholders": {
        "email": "Sisestage oma e-posti aadress",
        "feedback": "Sisestage oma tagasiside siia"
      }
    },
    "policies": "Jätkates nõustute meie {0} ja kinnitate meie {1} .",
    "privacyPolicy": "Privaatsuspoliitika",
    "success": "Teie tagasiside on saadetud.",
    "termsOfService": "Kasutustingimused",
    "thankYou": "Aitäh!",
    "title": "Saada tagasisidet",
    "validEmail": "Sisestage kehtiv e-posti aadress",
    "validFeedback": "Teie tagasiside peab koosnema vähemalt 5 sõnast"
  },
  "fieldLabels": {
    "default": {
      "dcContributor": "Kaasautorid",
      "dcCoverage": "Koht-aeg",
      "dcCreator": "Looja",
      "dcDate": "Kuupäev",
      "dcDescription": "Kirjeldus",
      "dcDuration": "Kestus",
      "dcFormat": "Formaat",
      "dcIdentifier": "Identifikaator",
      "dcLanguage": "Keel",
      "dcPublisher": "Kirjastus",
      "dcRelation": "Seosed",
      "dcRights": "Õigused",
      "dcSource": "Allikas",
      "dcSubject": "Teema",
      "dcTitle": "Pealkiri",
      "dcType": "Objekti tüüp",
      "dctermsCreated": "Loomise kuupäev",
      "dctermsExtent": "Ulatus ",
      "dctermsHasPart": "Koosneb",
      "dctermsHasVersion": "Omab versiooni",
      "dctermsIsFormatOf": "On formaat",
      "dctermsIsPartOf": "On osa",
      "dctermsIsReferencedBy": "Viidatakse",
      "dctermsIsReplacedBy": "Asendatakse",
      "dctermsIsRequiredBy": "On vajalik",
      "dctermsIssued": "Väljaandmise kuupäev",
      "dctermsMedium": "Meedium",
      "dctermsProvenance": "Päritolu",
      "dctermsReferences": "Viitab",
      "dctermsSpatial": "Kohad",
      "dctermsTOC": "Sisukord",
      "dctermsTemporal": "Ajaline",
      "edmCountry": "Pakkuja riik",
      "edmCurrentLocation": "Praegune asukoht",
      "edmDataProvider": "Pakkuja institutsioon",
      "edmHasMet": "On kohtunud",
      "edmIncorporates": "Sisaldab",
      "edmIntermediateProvider": "Vahendusteenuse osutaja",
      "edmIsDerivativeOf": "Tuleneb",
      "edmIsRelatedTo": "On seotud",
      "edmIsRepresentationOf": "Esindab",
      "edmIsSimilarTo": "on sarnane",
      "edmIsSuccessorOf": "on järeltulija",
      "edmProvider": "Pakkuja",
      "edmRealizes": "Mõistab",
      "edmRights": "Selle kirje meediumite litsents (kui pole teisiti täpsustatud)",
      "edmUgc": "Kasutaja loodud sisu",
      "europeanaCollectionName": "Kollektsiooni nimi",
      "keywords": "Märksõnad (kogukonna poolt antud)",
      "timestampCreated": "Ajatempel loodud",
      "timestampUpdate": "Ajatempel värskendatud",
      "wasPresentAt": "Oli kohal",
      "year": "Aasta"
    },
    "webResource": {
      "about": "RDF kohta",
      "dcDescription": "Kirjeldus",
      "ebucoreHasMimeType": "Ebucore MIME tüüp",
      "edmRights": "Selle meediumiressursi litsents",
      "rdfAbout": "RDF kohta"
    }
  },
  "filter": "Filter",
  "filterResults": "Filtreeri tulemusi",
  "footer": {
    "customiseWebsiteLanguage": "Kohandage veebisaidi keelt",
    "disclaimerLine1": "Europeana on Euroopa Liidu algatus, mida rahastavad Euroopa Liidu Euroopa ühendamise rahastu ja Euroopa Liidu liikmesriigid. Europeana teenuseid, sealhulgas seda veebisaiti, haldab konsortsium, mida juhib sihtasutuse Europeana sihtasutus Euroopa Komisjoni teenuslepingu alusel.",
    "disclaimerLine2": "Euroopa Komisjon ei taga teabe õigsust ega võta mingit vastutust sellel veebisaidil oleva teabe eest. Euroopa Komisjon ega ükski Euroopa Komisjoni nimel tegutsev isik ei vastuta ega vastuta sellel veebisaidil oleva teabe õigsuse ega kasutamise eest.",
    "findUsElsewhere": "Leidke meid mujalt",
    "imageDescription": "Rahastab Euroopa Liit",
    "navigation": {
      "MoreInfoLabel": "Rohkem infot",
      "about": "Meist",
      "accessibility": "Juurdepääsetavus",
      "cookies": "Küpsised",
      "forDevelopers": "Arendajatele",
      "help": "Abimaterjal",
      "privacy": "Privaatsuspoliitika",
      "provide": "Hakka andmepakkujaks",
      "subscribe": "Telli meie uudiskiri",
      "terms": "Kasutustingimused"
    },
    "ourMission": "Meie missioon",
    "ourMissionQuote": "Europeana annab kultuuripärandisektorile digitaalse ümberkujundamise võimaluse. Arendame teadmisi, tööriistu ja poliitikaid, et omaks võtta digitaalsed muutused ja julgustada partnerlussuhteid, mis edendavad innovatsiooni."
  },
  "formatting": {
    "ellipsis": "…",
    "listSeperator": ";"
  },
  "galleries": {
    "description": "Tutvuge meie galeriidega",
    "galleries": "Galeriid"
  },
  "goToRecord": "Mine kirje juurde",
  "header": {
    "backToMenu": "Sulge otsinguaken",
    "clearQuery": "Kustuta otsingupäring",
    "closeSidebar": "Sule menüü",
    "entireCollection": "Otsi {query} kogu meie kollektsioonist",
    "europeanaHome": "Europeana avaleht",
    "inCollection": "Otsi {query} {collection}",
    "navigation": {
      "about": "Meist",
      "collections": "Kogud",
      "europeanaClassroom": "Õpetajate jaoks",
      "help": "Abimaterjal",
      "home": "Kodu",
      "pro": "Professionaalidele",
      "stories": "Lood"
    },
    "quickSearch": "Kiire otsing",
    "searchFor": "Otsi {query}",
    "searchForEverything": "Otsi kõike",
    "searchForEverythingInCollection": "Otsi kõike {collection}",
    "searchForEverythingInEntireCollection": "Otsi kõike kogu meie kollektsioonist",
    "searchForm": "Otsinguvorm",
    "showSidebar": "Kuva menüü",
    "sideNavigation": "Külgmine navigeerimine"
  },
  "homeLinkAlt": "Europeana avaleht",
  "homePage": {
    "discoverEditorial": "Viimased lood",
    "storiesCTA": "Vaata kõiki lugusid",
    "subHeadline": "Otsi, salvesta ja jaga kunsti, raamatuid, filme ja muusikat tuhandetest kultuuriasutustest",
    "themesCTA": "Vaadake kõiki teemasid",
    "themesTitle": "Uurige teemade kaupa",
    "title": "Avastage Euroopa kultuuripärandit {digital} kujul",
    "titleDigital": "digitaalsel"
  },
  "imageSlider": {
    "handle": "Liugkäepide"
  },
  "items": {
    "itemCount": "1 toode | {count} toodet",
    "itemOf": "{max} / {count} tootest",
    "recent": "Hiljutised esemed",
    "recommended": "Soovitatavad esemed",
    "youMightLike": "Tooted, mis võivad teile meeldida"
  },
  "klaro": {
    "main": {
      "acceptAll": "Võtke kõik vastu",
      "acceptSelected": "Aktsepteeri valitud",
      "consentModal": {
        "description": "Võtame teie andmete privaatsust tõsiselt. Siin saate hinnata ja kohandada teenuseid, mida soovime sellel veebisaidil kasutada. Teie olete juhtiv! Lubage või keelake teenused oma äranägemise järgi.",
        "title": "Teenused, mida sooviksime kasutada."
      },
      "consentNotice": {
        "description": "Me hoolime teie privaatsusest ja kasutame andmeid ainult teie kogemuste parandamiseks. Me ei kasuta reklaamimiseks isiklikke andmeid. Oma nõusolekut saate muuta iga 15 päeva tagant.",
        "learnMore": "Las ma valin"
      },
      "decline": "ma keeldun",
      "ok": "Okei",
      "purposes": {
        "essential": {
          "description": "Need teenused on selle veebisaidi korrektseks toimimiseks hädavajalikud. Need sisaldavad otsingutulemite vaadet ja keele-eelistusi, säilitavad sisselogitud oleku ja hoiavad teie külastuse turvalisena. Te ei saa neid keelata, kuna veebisait ei töötaks muidu õigesti.",
          "title": "Olulised teenused turvalisuse ja kohandamise jaoks"
        },
        "usage": {
          "description": "Need teenused koguvad teavet, mis aitab meil paremini mõista, kuidas veebilehte kasutatakse ja kus on valupunktid, mis võimaldab meil teha teadlikke valikuid, et parandada teie kasutuskogemust.",
          "title": "Teenused veebisaidi kasutamise ja tagasiside kogumiseks"
        }
      },
      "service": {
        "disableAll": {
          "description": "Selle lüliti abil saate lubada või keelata kõik valikulised teenused.",
          "title": "Luba või keela kõik teenused"
        }
      }
    },
    "services": {
      "abTest": {
        "description": "Aitab meie veebisaiti täiustada, rakendades aeg -ajalt eksperimentaalseid muudatusi.",
        "title": "A/B testimine"
      },
      "auth-strategy": {
        "description": "Mäletab sisselogimiseks kasutatava autoriseerimisstrateegia.",
        "title": "Auth strateegia"
      },
      "debugSettings": {
        "description": "Aitab siluda API taotlusi",
        "title": "Debugimise lüliti"
      },
      "hotjar": {
        "description": "Aktiveerib uuringu vidina, andes teile võimaluse vastata meie külastajate rahulolu uuringutele.",
        "title": "Hotjar"
      },
      "i18n": {
        "description": "Jätab teie eelistatud liidese keele edaspidiseks kasutamiseks meelde.",
        "title": "Keelekood"
      },
      "jira-servicedesk": {
        "description": "Aktiveerib tagasiside vidina, andes teile võimaluse meiega ühendust võtta.",
        "title": "Jira teeninduslaud"
      },
      "matomo": {
        "description": "Kogub anonüümset statistikat selle kohta, kuidas külastajad veebisaidiga suhtlevad.",
        "title": "Matomo"
      },
      "newFeatureNotification": {
        "description": "Kuvab teate, kui uued funktsioonid muutuvad kättesaadavaks.",
        "title": "Uus funktsiooniteatis"
      },
      "searchResultsView": {
        "description": "Mäletab, kas eelistate näha otsingutulemusi loendi või ruudustiku kujul.",
        "title": "Otsingutulemite vaade (loend / ruudustik)"
      }
    }
  },
  "layout": {
    "skipToMain": "Otse lehekülje sisule"
  },
  "learnMore": "Lisateave selle kirjelduse allika kohta",
  "loading": "Laadimine",
  "loadingResults": "Tulemuste laadimine",
  "messages": {
    "copyToClipboardSuccess": "Kopeeritud lõikelauale",
    "externalContentError": "Välist sisu ei õnnestunud laadida",
    "notFound": "Ei leitud",
    "paginationLimitExceeded": "Võimalik on vaadata ainult esimesi {limit} otsingutulemusi."
  },
  "modal": {
    "download": {
      "clickToCopy": "Selle kopeerimiseks klõpsake omistusel",
      "modalIntro": "Kui kasutate seda üksust veebis või mujal, ärge unustage selle kõrval kuvada järgmist omistust:",
      "modalTitle": "Ütle aitäh"
    }
  },
  "multilingual": {
    "automated": "Automatiseeritud tõlge",
    "enrichment": "Rikastamine partner projektide kaudu",
    "other": "Muud keeled",
    "stopTranslating": "Lõpetage selle üksuse tõlkimine keelde {0}.",
    "translateLanguage": "Kas soovite seda üksust domeenis {0} ?",
    "translateQuotaError": "Tõlketeenus pole ajutiselt saadaval. Palun proovi hiljem uuesti."
  },
  "newFeatureNotification": {
    "dismiss": "Sulge",
    "readMore": "Loe lähemalt",
    "text": {
      "searchFilters": "Nüüd saate otsida väärtusi üksikutes filtrites; vaadake seda!"
    }
  },
  "newWindow": "avaneb uues aknas",
  "noMoreResults": "Teie otsingupäringule pole rohkem tulemusi.",
  "noResults": "Ühtki tulemust",
  "of": "of",
  "organisation": {
    "city": "Linn",
    "country": "Riik",
    "englishName": "Ingliskeelne nimi",
    "nameAcronym": "Nime akronüüm"
  },
  "pageHasLoaded": "on laaditud",
  "pageNumber": "Lehekülje number",
  "pages": {
    "collections": {
      "organisations": {
        "table": {
          "name": "Nimi"
        },
        "title": "Organisatsioonid"
      },
      "persons": {
        "title": "Isikud"
      },
      "places": {
        "title": "Kohad"
      },
      "table": {
        "items": "Üksused",
        "name": "Nimi"
      },
      "times": {
        "title": "Korda"
      },
      "topics": {
        "title": "Teemad"
      }
    }
  },
  "pagination": {
    "label": "Paginatsioon"
  },
  "readMore": "Loe lähemalt",
  "recommendation": {
    "prompts": {
      "accept": "Pöidla üles, et lisada galeriisse",
      "reject": "Pöidla alla, kui see sulle ei meeldi"
    }
  },
  "record": {
    "IIIFViewer": "IIIF vaataja",
    "actions": {
      "pin": "Kinnitage üksus saadaolevatele olemitega"
    },
    "allMetaData": "Kogu metateave",
    "copyEmbedLabel": "Embed code (Klõpsake kopeerimiseks)",
    "exploreMore": "Avastage rohkem",
    "extendedInformation": "Täiendav teave",
    "goodToKnow": "Hea teada",
    "hideAll": "Peida kogu teave",
    "location": "Asukoht",
    "locationOnMap": "Asukoht kaardil",
    "mediaPlayer": "Meediumipleier",
    "record": "Kirje",
    "showAll": "Kuva kogu teave",
    "similarItems": "Sarnased tooted",
    "status": {
      "unpublished": "[Avaldamata üksus]"
    },
    "transcription": "Transkriptsioon",
    "transcriptionDisclaimer": "See sisu on saadud eraisikult, mitte eset pakkunud institutsioonilt."
  },
  "related": {
    "editorial": {
      "title": "Lood, mis teile võivad meeldida"
    }
  },
  "relatedCollections": "Seotud kollektsioonid",
  "removeFilter": "Eemalda filter {filterLabel}",
  "reset": "Lähtesta",
  "resourceWikimedia": "Wikimedia Commonsist saadud ressurss",
  "results": "Tulemused",
  "resultsFor": "Tulemused päringule {0}",
  "resultsLimitWarning": "Täiendavaid tulemusi ei kuvata, kuna kuvatakse ainult esimesed 1000 kõige asjakohasemat tulemust. Kui te pole leidnud seda, mida otsite, kaaluge oma otsingu täpsustamist.",
  "resultsWithin": "Tulemused vahemikus {0} {1} päringule {2}",
  "search": {
    "boost": {
      "placeholder": "Sisestage välja võimendamise päring"
    },
    "title": "Otsing"
  },
  "searchHasLoaded": "{0} tagastatud tulemused",
  "searchPlaceholder": "Otsi 50+ miljonit üksust",
  "searchResults": "Otsing",
  "searchResultsFor": "{0} - otsing",
  "searchSuggestions": "Otsige soovitusi",
  "searchTier": {
    "button": {
      "hide": "Peida need üksused",
      "show": "Näita neid üksusi"
    },
    "text": {
      "hide": "Kuvatakse üksusi, mis ei vasta meie avaldamiskriteeriumidele.",
      "show": "Rohkem üksusi vastab teie otsingule, kuid ei vasta meie avaldamiskriteeriumidele."
    }
  },
  "searchViews": {
    "grid": "Võrguvaade",
    "list": "Loendivaade",
    "mosaic": "Mosaiikvaade"
  },
  "set": {
    "actions": {
      "addTo": "Lisa galeriisse",
      "create": "Loo galerii",
      "createNew": "Loo uus galerii",
      "delete": "Kustuta galerii",
      "edit": "Redigeeri galeriid",
      "update": "Värskenda galeriid"
    },
    "form": {
      "description": "Galerii kirjeldus",
      "private": "Hoia see galerii privaatsena",
      "required": "Kohustuslik väli",
      "title": "Galerii nimi"
    },
    "labels": {
      "curatedBy": "Kuraator",
      "private": "Privaatgalerii"
    },
    "notifications": {
      "deleted": "Teie galerii on kustutatud.",
      "likeLimit": {
        "body": "Vabandame, kuid praegu piirdute maksimaalselt 100 toote meeldimisega. Varsti eemaldame selle limiidi!",
        "title": "100 meeldimist"
      },
      "updated": "Üksus lisati galeriisse."
    },
    "prompts": {
      "delete": "Kas soovite kindlasti selle galerii kustutada? Kui kustutate selle galerii, kaotate kõik sinna lisatud tooted."
    }
  },
  "showLess": "Näita vähem",
  "showMore": "Näita rohkem",
  "sideFilters": {
    "noOptions": "Valimiseks pole valikuid",
    "search": "Otsing"
  },
  "statuses": {
    "liked": "Meeldis",
    "pinned": "Kinnitatud"
  },
  "storiesPage": {
    "title": "Lood"
  },
  "website": "Veebisait",
  "youMightAlsoLike": "Sulle võib ka meeldida"
};
